import React from 'react';
import { Star } from 'lucide-react';
export function ReviewsSection() {
  const reviews = [{
    text: "I've been dealing with insomnia for 15 years. Tried everything from melatonin to Ambien to magnesium glycinate. This is the FIRST thing that actually addresses why I can't sleep. No more 3AM wake-ups.",
    author: 'Lisa T., Verified Buyer'
  }, {
    text: 'Been on Ambien for 8 years. Scared of dementia. LyraSleep works just as well—I fall asleep fast and stay asleep—but without the grogginess or addiction worry. Wish I found this sooner.',
    author: 'David M., Verified Buyer'
  }, {
    text: "My brain usually won't shut off. I'll replay work conversations at midnight. These gummies calm my mind in about 20 minutes and I drift off naturally. Not knocked out—just calm. Game changer.",
    author: 'Jennifer K., Verified Buyer'
  }, {
    text: "I was skeptical. I've tried EVERYTHING. But the ingredient doses are legit (I researched every one). First night I slept 7 hours straight. Woke up clear. No fog. I cried.",
    author: 'Amanda R., Verified Buyer'
  }, {
    text: "I have severe anxiety and PTSD. Most sleep aids don't touch it. LyraSleep actually addresses the root cause—my nervous system. For the first time in 10 years, I sleep through the night.",
    author: 'Rachel W., Verified Buyer'
  }];
  return <div className="my-16" data-id="element-355">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8" data-id="element-356">
        REAL REVIEWS: From Chronic Insomniacs Like You
      </h2>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-357">
        {reviews.map((review, index) => <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-200" data-id="element-358">
            <div className="flex gap-1 mb-3" data-id="element-359">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-360" />)}
            </div>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-361">
              "{review.text}"
            </p>
            <p className="text-sm font-semibold text-gray-900" data-id="element-362">
              — {review.author}
            </p>
          </div>)}
      </div>
    </div>;
}